/**
 * 电站列表搜索：整段输入为纯数字时走 stationId，否则走名称
 * @param {unknown} raw
 * @returns {{ name: string, stationId: string }}
 */
export function stationSearchNameOrId(raw) {
  const q = String(raw ?? '').trim()
  if (!q) return { name: '', stationId: '' }
  if (/^\d+$/.test(q)) return { name: '', stationId: q }
  return { name: q, stationId: '' }
}
